var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMexcLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_156_179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.0325 62.5825L76.6837 25.5518C72.004 17.8314 60.5912 17.7524 56.0734 25.8796L33.6584 64.3911C29.4723 71.4521 34.6456 80.3178 43.0217 80.3178H87.9347C96.3897 80.3178 102.712 71.2033 98.0325 62.5825Z",
    fill: "#3156AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2417 65.4563L65.9266 63.1579C64.6945 61.0214 61.9854 56.4247 61.9854 56.4247L43.9223 25.0571C39.2426 18.079 28.1575 17.5025 23.4778 26.2892L2.45681 62.6643C-1.89509 70.3018 3.27822 80.2338 12.7205 80.3167H57.3887H76.4391H87.769C76.1943 80.3996 72.4979 74.4049 67.2417 65.4563Z",
    fill: "#1972E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.2456 65.4564L65.9306 63.158C64.6985 61.0216 61.9894 56.4248 61.9894 56.4248L50.3277 35.8975L33.5757 64.4731C29.3896 71.5341 34.5629 80.4037 42.935 80.4037H57.3058H76.3562H87.769C76.1113 80.3168 72.4979 74.405 67.2456 65.4564Z",
    fill: "url(#paint0_linear_156_179)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_156_179",
    x1: 28.6842,
    y1: 51.5095,
    x2: 77.3374,
    y2: 70.6401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#264CA2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#234588"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_156_179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 98.7273,
    height: 98.7273,
    fill: "white",
    transform: "translate(0.896973 0.714844)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMexcLogo);
export default __webpack_public_path__ + "static/media/mexc-logo.3cf4b34045f895e472725be430b5bc5a.svg";
export { ForwardRef as ReactComponent };